/* ============================================================
   LIFULL — Homepage JS  |  lifull-homepage.js
   Unified animation coordinator: scroll reveals, counters, parallax.
   ============================================================ */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1. Scroll-reveal system ── */
  /* Watches .lf-reveal, .lf-reveal-left, .lf-reveal-right, .lf-reveal-scale */
  /* Delay can be set via data-lf-delay="200" (ms) on the element              */

  var revealSelectors = '.lf-reveal, .lf-reveal-left, .lf-reveal-right, .lf-reveal-scale';

  function initReveal() {
    var elements = Array.prototype.slice.call(document.querySelectorAll(revealSelectors));
    if (!elements.length) return;

    if (prefersReducedMotion) {
      elements.forEach(function (el) {
        el.classList.add('in');
      });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-lf-delay') || '0', 10);
        el.style.setProperty('--lf-d', delay + 'ms');
        /* rAF ensures the delay property is painted before the class flip */
        requestAnimationFrame(function () {
          el.classList.add('in');
        });
        obs.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(function (el) { obs.observe(el); });
  }

  /* ── 2. Animated counters ── */
  /* Usage: <span data-lf-counter="2400" data-lf-suffix="+">0</span> */

  function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }

  function animateCounter(el) {
    var target  = parseFloat(el.getAttribute('data-lf-counter') || '0');
    var suffix  = el.getAttribute('data-lf-suffix') || '';
    var prefix  = el.getAttribute('data-lf-prefix') || '';
    var decimals = (String(target).split('.')[1] || '').length;
    var duration = parseInt(el.getAttribute('data-lf-duration') || '1800', 10);
    var start    = null;

    function step(ts) {
      if (!start) start = ts;
      var elapsed  = ts - start;
      var progress = Math.min(elapsed / duration, 1);
      var value    = easeOutQuart(progress) * target;
      el.textContent = prefix + value.toFixed(decimals) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    var counters = Array.prototype.slice.call(document.querySelectorAll('[data-lf-counter]'));
    if (!counters.length) return;

    if (prefersReducedMotion) {
      counters.forEach(function (el) {
        var target  = el.getAttribute('data-lf-counter') || '0';
        var suffix  = el.getAttribute('data-lf-suffix') || '';
        var prefix  = el.getAttribute('data-lf-prefix') || '';
        el.textContent = prefix + target + suffix;
      });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animateCounter(entry.target);
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.5 });

    counters.forEach(function (el) { obs.observe(el); });
  }

  /* ── 3. Parallax coordinator ── */
  /* Usage: <div data-lf-parallax="0.08"> — value is scroll ratio (0–1)  */
  /* Elements marked data-lf-parallax="img" get the default 0.07 ratio   */

  var parallaxEls = [];
  var parallaxTicking = false;

  function collectParallaxEls() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('[data-lf-parallax]'));
    nodes.forEach(function (el) {
      var val = el.getAttribute('data-lf-parallax');
      var ratio = (val === 'img' || val === '') ? 0.07 : parseFloat(val) || 0.07;
      parallaxEls.push({ el: el, ratio: ratio });
    });
  }

  function updateParallax() {
    var vh = window.innerHeight;
    parallaxEls.forEach(function (item) {
      var rect = item.el.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < vh) {
        var center = (rect.top + rect.height * 0.5) - vh * 0.5;
        var offset = center * item.ratio;
        item.el.style.transform = 'translateY(' + offset.toFixed(2) + 'px)';
      }
    });
    parallaxTicking = false;
  }

  function initParallax() {
    if (prefersReducedMotion) return;
    collectParallaxEls();
    if (!parallaxEls.length) return;

    window.addEventListener('scroll', function () {
      if (!parallaxTicking) {
        requestAnimationFrame(updateParallax);
        parallaxTicking = true;
      }
    }, { passive: true });

    updateParallax();
  }

  /* ── 4. Bootstrap on DOM ready ── */
  function boot() {
    initReveal();
    initCounters();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
